
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.012 19.391H2.863A1.863 1.863 0 011 17.528V3.863C1 2.834 1.834 2 2.863 2h16.15c1.029 0 1.863.834 1.863 1.863v13.665c0 1.03-.834 1.863-1.864 1.863zM5.97 5.416a1.553 1.553 0 100 3.106 1.553 1.553 0 000-3.106zm0 3.727a1.553 1.553 0 100 3.105 1.553 1.553 0 000-3.105zm0 3.727a1.553 1.553 0 100 3.105 1.553 1.553 0 000-3.105zm11.18-5.28V6.348a.466.466 0 00-.466-.466H8.92a.466.466 0 00-.466.466V7.59c0 .257.209.466.466.466h7.764a.466.466 0 00.466-.466zm0 3.727v-1.242a.466.466 0 00-.466-.466H8.92a.466.466 0 00-.466.466v1.242c0 .257.209.466.466.466h7.764a.466.466 0 00.466-.466zm0 3.726v-1.242a.466.466 0 00-.466-.466H8.92a.466.466 0 00-.466.466v1.242c0 .258.209.466.466.466h7.764a.466.466 0 00.466-.466z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_menu_corretor.svg